import { Component } from '@angular/core';

@Component({
  selector: 'fsx-help',
  templateUrl: './help.component.html',
  styleUrls: ['./help.component.scss'],
})
export class HelpComponent {}
